import { PROCESS_TYPE } from 'features/sendouts/constants/constants';
import { convertSendover } from 'features/sendouts/services/convertSendover';
import { createProcess } from 'features/sendouts/services/createProcess';
import { createSendoutInterview } from 'features/sendouts/services/createSendoutInterview';
import { submitInterviewCall } from 'features/sendouts/services/submitInterviewCall';
import { updateSendoutDetails } from 'features/sendouts/services/updateSendoutDetails';
import { updateSendoutInterview } from 'features/sendouts/services/updateSendoutInterview';
import { updateSendoverDetails } from 'features/sendouts/services/updateSendoverDetails';

import { DRAWER_TYPES } from './DrawerStack.types';

export const SUBMIT_CONFIG = {
  [DRAWER_TYPES.CallEditor]: {
    handler: async () => ({})
  },
  [DRAWER_TYPES.CreateSendout]: {
    handler: async ({ meta, payload }) => ({
      ...(await createProcess({
        processType: PROCESS_TYPE.Sendout,
        jobOrderId: meta?.props?.jobOrderId,
        payload: payload?.payload
      })),
      effects: { refreshTable: true }
    })
  },
  [DRAWER_TYPES.CreateSendover]: {
    handler: async ({ meta, payload }) => ({
      ...(await createProcess({
        processType: PROCESS_TYPE.Sendover,
        jobOrderId: meta?.props?.jobOrderId,
        payload: payload?.payload
      })),
      effects: { refreshTable: true }
    })
  },
  [DRAWER_TYPES.ConvertSendoverToSendout]: {
    handler: async ({ meta, payload }) => ({
      ...(await convertSendover({
        sendoverId: meta?.props?.sendover?.id,
        payload: payload?.payload
      })),
      effects: { refreshTable: true }
    })
  },
  [DRAWER_TYPES.SendoutDetailsEdit]: {
    handler: async ({ meta, payload }) => ({
      ...(await updateSendoutDetails({
        sendoutId: meta?.props?.sendoutId,
        payload: payload?.payload
      })),
      effects: {
        refreshTable: true
      }
    })
  },
  [DRAWER_TYPES.SendoverDetailsEdit]: {
    handler: async ({ meta, payload }) => ({
      ...(await updateSendoverDetails({
        sendoverId: meta?.props?.sendoverId,
        payload: payload?.payload
      })),
      effects: {
        refreshTable: true
      }
    })
  },
  [DRAWER_TYPES.CreateSendoutInterview]: {
    handler: async ({ meta, payload }) => ({
      ...(await createSendoutInterview({
        sendoutId: meta?.props?.sendoutId,
        payload: payload?.payload
      })),
      effects: {
        refreshTable: true
      }
    })
  },
  [DRAWER_TYPES.SendoutInterviewDetails]: {
    handler: async ({ meta, payload }) => {
      if (payload?.callType) {
        return submitInterviewCall({
          callType: payload.callType,
          interviewId: meta?.props?.interviewId,
          itemId: payload?.existingItemId,
          payload: payload?.payload
        });
      }

      return {
        ...(await updateSendoutInterview({
          sendoutId: meta?.props?.sendoutId,
          interviewId: meta?.props?.interviewId,
          payload: payload?.payload
        })),
        effects: {
          refreshTable: true
        }
      };
    }
  }
};
